<template>
  <div
    v-if="
      permissions.editTeamInfo ||
        permissions.editTeamMembers ||
        permissions.delete
    "
  >
    <Menu
      data-testid="teamCard-options"
      :closeOnContentClick="false"
      :options="teamOptions"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-on="on" v-bind="attrs" icon small>
          <v-icon color="blue-grey lighten-1" size="24"
            >mdi-dots-vertical</v-icon
          >
        </v-btn>
      </template>
    </Menu>

    <TeamFormDialog
      v-if="isTeamFormVisible"
      :show="isTeamFormVisible"
      :team="team"
      :organizationId="organizationId"
      :siteId="siteId"
      @close="isTeamFormVisible = false"
      @updated="handleTeamUpdated"
      @created="handleTeamCreated"
    />

    <DeleteConfirmation
      v-if="isDeleteConfirmationVisible"
      :show="isDeleteConfirmationVisible"
      :teamId="team.id"
      @cancel="isDeleteConfirmationVisible = false"
      @deleted="handleDeleteSuccess"
    />
  </div>
</template>

<script>
import mixin from '@/mixins/mixin.vue'
import teamPermissions from '@/mixins/teamPermissions.vue'
import { mapGetters } from 'vuex'

import TeamFormDialog from '@/components/TeamFormDialog.vue'
import DeleteConfirmation from './TeamDeleteConfirmation.vue'
import Menu from '@/components/UI/Menu.vue'
import _ from 'lodash'

export default {
  mixins: [mixin, teamPermissions],

  components: {
    TeamFormDialog,
    DeleteConfirmation,
    Menu,
  },

  props: {
    team: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isDeleteConfirmationVisible: false,
      isTeamFormVisible: false,
    }
  },

  computed: {
    ...mapGetters(['organizationId', 'siteId']),

    permissions() {
      return this.getTeamPermissions({ team: this.team })
    },

    teamOptions() {
      return _.compact([
        (this.permissions.editTeamInfo || this.permissions.editTeamMembers) && {
          title: this.$t('common.button.edit'),
          id: 0,
          testId: 'teamCard-button-edit',
          icon: 'mdi-pencil-outline',
          action: () => this.teamFormVisible(),
        },
        this.permissions.delete && {
          title: this.$t('common.button.delete'),
          id: 1,
          testId: 'teamCard-button-delete',
          icon: 'mdi-delete-outline',
          action: () => this.deleteConfirmationVisible(),
        },
      ])
    },
  },

  methods: {
    deleteConfirmationVisible() {
      this.isDeleteConfirmationVisible = true
    },

    teamFormVisible() {
      this.isTeamFormVisible = true
    },

    handleDeleteSuccess() {
      this.isDeleteConfirmationVisible = false
      this.$emit('deleted')
    },

    handleTeamUpdated(team) {
      this.isTeamFormVisible = false
      this.$emit('updated', team)
    },

    handleTeamCreated(team) {
      this.navigateTo({
        name: 'teamDetails',
        params: { teamId: team.id },
      })
    },
  },
}
</script>
